import "@fontsource/noto-sans-tc/300.css"
import "@fontsource/noto-sans-tc/700.css"
import "@fontsource/noto-sans-tc/900.css"
import '@nathanvda/cocoon'
import 'core-js'
import Cookies from 'js-cookie'
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Thumbs } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'public/js/svgxuse.min';
import 'public/js/flatpickr';
import 'public/js/custom_alert.js'
import 'devbridge-autocomplete'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;
window.Cookies = Cookies;

// JavaScript
$(document).ready(function () {
  $('#mobileMenuBtn').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu').toggleClass('active');
    $('#header').toggleClass('active');
  });

  $('#userBtn, .user-mask, .menu-close').on('click', function () {
    $('#userBtn').toggleClass('active');
    $('.header-user-menu').toggleClass('active');
    $('.user-mask').toggleClass('active');
  });

  $(".header-menu-item.group-link").on("click", function () {
    $(this).toggleClass('is-active');
  });
  $('.header-menu-nav').find('a').on('click', function () {
    $('#mobileMenuBtn').toggleClass('active');
    $('.header-menu').removeClass('active');
    $('#header').removeClass('active');
  });


  $(".back-to-top").on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 300, 'swing');
  });
  var window_width = $(window).width();
  var scroll_change = 20;
  if (window_width > 900) {
    var scroll_change = 130;
  }
  if ($(window).scrollTop() > scroll_change) {
    $('.header').addClass("rwd-header");
    $(".back-to-top").fadeIn();
  } else {
    $('.header').removeClass("rwd-header");
    $(".back-to-top").fadeOut();
  }

  $(window).on('scroll', function () {
    // transparent header
    if ($(window).scrollTop() > scroll_change) {
      $('.header').addClass("rwd-header");
      $(".back-to-top").fadeIn();
    } else {
      $('.header').removeClass("rwd-header");
      $(".back-to-top").fadeOut();
    }
  });

  // file upload
  $('.upload-file').on('change', function() {
    let thisReferesTo = $(this).val().replace(/C:\\fakepath\\/i, '');
    $(this).siblings('.file-status').find('.file-name').html(thisReferesTo);
  })

  $('.file-reset').on('click', function(e) {
    e.preventDefault();
    $(this).parent('.upload-file').val('');
    $(this).siblings('.file-name').html('請選擇檔案');
  });

  $('.tab[data-tab]').on('click', function () {
    var tabPanes = $(this).data('tabs');
    var ID = $(this).data('tab');
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $("[data-tab-panes=" + tabPanes + "]").find("[data-tab-pane=" + ID + "]").addClass('is-active').siblings().removeClass('is-active');
  });

  var indexSocial = new Swiper('#indexSocial', {
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 4,
      },
      1025: {
        slidesPerView: 5,
      },
    }
  });
  // 首頁 count up
  const $counters = $('[data-countup]');

  function countUp($el, target, duration = 2000) {
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const current = Math.floor(progress * target);
      $el.text(current.toLocaleString());

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  $counters.each(function () {
    const $el = $(this);
    const target = parseInt($el.data('countup'), 10);
    countUp($el, target);
  });

  // 首頁 選擇運送目的國家 輪播項目
  if ( $('#indexCrossBordersLocations').length != 0 ) {
    var indexCrossBordersLocations = new Swiper("#indexCrossBordersLocations", {
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 5,
          spaceBetween: 20,
          slidesOffsetAfter: 80,
        },
        1025: { // >= 1025px 時
          slidesPerView: 3.5,
          spaceBetween: 20,
          slidesOffsetAfter: 80,
        },
        481: { // >= 481px 時
          slidesPerView: 2.8,
          spaceBetween: 20,
          slidesOffsetAfter: 60,
        },
        0: { // >= 0px 時
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetAfter: 60,
        }
      },
    });
  }

  // accordion
  $('.accordion-item .accordion-title-group').click(function(){
    $(this).parent('.accordion-item').toggleClass('active').siblings().removeClass('active').find('.accordion-content').slideUp(200);
    $(this).siblings('.accordion-content').slideToggle(200);
  });

  // FAQ tabs
  $('.faq-tabs .faq-tab-link').on('click', function(e) {
    e.preventDefault();
    
    var $tab = $(this);
    var $parent = $tab.closest('.faq-category-content, .faqs-block, .faq-content');
    var index = $tab.parent('.faq-tab-item').index();
    
    $tab.addClass('active').parent('.faq-tab-item').siblings().find('.faq-tab-link').removeClass('active');
    
    $parent.find('.faq-subcategory-content').removeClass('active').eq(index).addClass('active');
  });

  // Amazon SEND FAQ
  $('.amazon-send-faq .faq-main-tab-link').on('click', function(e) {
    e.preventDefault();
    
    var category = $(this).data('category');
    var $targetContent = $('.amazon-send-faq .faq-category-content[data-category="' + category + '"]');
    
    $('.amazon-send-faq .faq-main-tab-link').removeClass('active');
    $(this).addClass('active');
    
    $('.amazon-send-faq .faq-category-content').removeClass('active');
    $targetContent.addClass('active');
    
    // 重置子分類 Tab 為第一個
    if ($targetContent.find('.faq-tabs').length > 0) {
      $targetContent.find('.faq-tab-link').removeClass('active').first().addClass('active');
      $targetContent.find('.faq-subcategory-content').removeClass('active').first().addClass('active');
    }
  });

  // about award
  var aboutAward = new Swiper('#aboutAward', {
    grabCursor: true,
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3,
      },
      1025: {
        slidesPerView: 4,
      },
    }
  });

  // 最新消息 banner
  var postTop = new Swiper('#postTop', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  // news show left menu - 自動生成目錄
  function generateTableOfContents() {
    const contentArea = document.querySelector('.custom-editor');
    const tocContainer = document.querySelector('.news-show-left ul');
    
    if (!contentArea || !tocContainer) return;

    tocContainer.innerHTML = '';
    const headings = contentArea.querySelectorAll('h2');
    
    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();

      if (!heading.id) {
        heading.id = `heading-${index + 1}`;
      }

      const li = document.createElement('li');
      li.className = 'toc-item';
      
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = text;
      link.className = 'toc-link';

      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetElement = document.getElementById(heading.id);
        if (targetElement) {
          // 使用 getBoundingClientRect 獲取更準確的位置
          const header = document.querySelector('.header');
          const headerHeight = header ? header.offsetHeight : 0;
          const targetRect = targetElement.getBoundingClientRect();
          const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const targetPosition = currentScrollTop + targetRect.top - headerHeight - 10; // 減少到 10px 間距
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
      
      li.appendChild(link);
      tocContainer.appendChild(li);
    });

    const faqHeading = document.getElementById('article-faqs');
    if (faqHeading) {
      const li = document.createElement('li');
      li.className = 'toc-item';

      const link = document.createElement('a');
      link.href = '#article-faqs';
      link.textContent = '常見問題';
      link.className = 'toc-link';

      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetElement = document.getElementById('article-faqs');
        if (targetElement) {
          const header = document.querySelector('.header');
          const headerHeight = header ? header.offsetHeight : 0;
          const targetRect = targetElement.getBoundingClientRect();
          const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const targetPosition = currentScrollTop + targetRect.top - headerHeight - 10;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });

      li.appendChild(link);
      tocContainer.appendChild(li);
    }
  }
  

  if (document.querySelector('.news-show-container')) {
    generateTableOfContents();
  }
});

window.addEventListener('load', (event) => {
  AOS.init({
    disable: false,
    startEvent: 'DOMContentLoaded',
    initClassName: 'aos-init',
    animatedClassName: 'aos-animate',
    useClassNames: false,
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,
    offset: 120,
    delay: 0,
    duration: 400,
    easing: 'ease',
    once: true,
    mirror: false,
    anchorPlacement: 'top-bottom',
  });
});
